// checkoutSlice
import { apiSlice } from "./apiSlice";
import {
  GET_CART_URL,
  GET_DELIVERY_AREAS_URL,
  CREATE_ORDER_URL,
  FETCH_ORDER_URL,
  INITIATE_PAYMENT_URL,
} from "../constants";

export const checkoutSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchCart: builder.query({
      query: () => ({ url: GET_CART_URL, method: "GET" }),
    }),
    fetchDeliveryAreas: builder.query({
      query: (state) => ({
        url: `${GET_DELIVERY_AREAS_URL}?state=${state}`,
        method: "GET",
      }),
    }),
    createOrder: builder.mutation({
      query: (data) => ({
        url: CREATE_ORDER_URL,
        method: "POST",
        body: data,
      }),
    }),
    fetchOrder: builder.query({
      query: (orderId) => ({
        url: FETCH_ORDER_URL(orderId),
        method: "GET",
      }),
    }),
    initiatePayment: builder.mutation({
      query: (paymentData) => ({
        url: INITIATE_PAYMENT_URL,
        method: "POST",
        body: paymentData,
      }),
    }),
  }),
});

export const {
  useFetchCartQuery,
  useFetchDeliveryAreasQuery,
  useCreateOrderMutation,
  useFetchOrderQuery, // Add this export
  useInitiatePaymentMutation,
} = checkoutSlice;
